'use client';

import { ContactWidgetComponent } from './ContactWidgetComponent';

export function ContactWidgetComponentC(
  props: React.ComponentProps<typeof ContactWidgetComponent>,
) {
  return <ContactWidgetComponent {...props} />;
}
